var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.719,
    height: 74.654,
    viewBox: "0 0 107.719 74.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0.208 -0.286)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_9",
    "data-name": "Linha 9",
    x1: 36.789,
    y2: 72.046,
    transform: "translate(0.683 1.475)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_10",
    "data-name": "Linha 10",
    x2: 18.395,
    y2: 36.789,
    transform: "translate(19.08 37.574)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_11",
    "data-name": "Linha 11",
    x1: 18.395,
    y2: 35.257,
    transform: "translate(19.074 38.271)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_12",
    "data-name": "Linha 12",
    x2: 30.658,
    y2: 53.651,
    transform: "translate(28.258 20.674)",
    fill: "none",
    stroke: "#ca3e47",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_13",
    "data-name": "Linha 13",
    x1: 21.461,
    transform: "translate(36.789 73.939)",
    fill: "none",
    stroke: "#ca3e47",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_14",
    "data-name": "Linha 14",
    x2: 38.322,
    transform: "translate(18.395 37.15)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_15",
    "data-name": "Linha 15",
    x2: 19.928,
    y2: 36.79,
    transform: "translate(37.463 0.762)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_16",
    "data-name": "Linha 16",
    x1: 19.928,
    transform: "translate(0 73.939)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_17",
    "data-name": "Linha 17",
    x2: 80.895,
    transform: "translate(69.831 1.475) rotate(62.949)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_18",
    "data-name": "Linha 18",
    x2: 41.132,
    transform: "translate(88.222 37.574) rotate(116.565)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_19",
    "data-name": "Linha 19",
    x2: 39.767,
    transform: "translate(69.834 38.271) rotate(62.447)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_20",
    "data-name": "Linha 20",
    x2: 61.793,
    transform: "translate(79.045 20.674) rotate(119.745)",
    fill: "none",
    stroke: "#ca3e47",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_21",
    "data-name": "Linha 21",
    x2: 21.461,
    transform: "translate(49.053 73.939)",
    fill: "none",
    stroke: "#ca3e47",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_22",
    "data-name": "Linha 22",
    x2: 38.322,
    transform: "translate(88.908 37.15) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_23",
    "data-name": "Linha 23",
    x2: 41.84,
    transform: "matrix(-0.476, 0.879, -0.879, -0.476, 69.839, 0.762)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_24",
    "data-name": "Linha 24",
    x2: 19.928,
    transform: "translate(87.375 73.939)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3b24fb27.svg";
export { ForwardRef as ReactComponent };